<template>
  <v-app light id="app">
    <v-content>
      <!-- HEADER -->
      <v-container>
        <v-flex xs12 lg8 offset-lg2 text-xs-center>
          <img rel="preload" style='height: 60%; width: 70%; object-fit: contain' src="@/assets/logo.png">
        </v-flex>
      </v-container>

      <!-- ERROR -->
      <v-flex v-if="this.error" py-5 xs10 offset-xs1 md8 offset-md2 offset-lg4 lg4>
        <v-alert icon="mdi-alert-outline" title type="error" :value="this.error" outline>
          <v-flex headline font-weight-light>{{ this.errorMsg }}</v-flex>
        </v-alert>
      </v-flex>

      <!-- LOADING -->
      <v-container mt-5 v-if="this.loading" text-xs-center>
        <div xs-12 class="loader" ></div>
      </v-container>
  
      <!-- CONTENT -->
      <v-container v-if="!this.error && !this.loading">
        <today :today="this.today" />
  
        <!-- OPEN/CLOSE MONATSPLAN -->
        <v-container pt-4 xs12 text-xs-center white--text>
          <v-flex class="display-2">Monatsplan</v-flex>
          <v-flex py-4>
            <v-btn fab outline dark @click="planShown = !planShown">
                <svg v-if="!planShown" style="width:32px;height:32px" viewBox="0 0 24 24">
                  <path fill="#EEEEEE" d="M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z"/>
                </svg>
                <svg v-else style="width:32px;height:32px" viewBox="0 0 24 24">
                    <path fill="#EEEEEE" d="M16.59,5.41L15.17,4L12,7.17L8.83,4L7.41,5.41L12,10M7.41,18.59L8.83,20L12,16.83L15.17,20L16.58,18.59L12,14L7.41,18.59Z"/>
                </svg>
            </v-btn>
          </v-flex>
        </v-container>
        <!-- MONATSPLAN -->
        <plan v-if="this.planShown" :month="this.plan" :today="this.today" />
        <!-- INFO -->
        <v-flex pt-3 xs12 lg8 offset-lg2 text-xs-center v-if="!planShown">
          <img rel="preload" style='height: 40%; width: 40%; object-fit: contain' src="@/assets/koch.png">
        </v-flex>
      </v-container>
    </v-content>
  
    <!-- FOOTER -->
    <v-footer height="auto" id="footer">
      <v-layout column>
        <v-flex title pb-2 xs-12 text--darken grey--text text-xs-center>
          Awesome since 1977
        </v-flex>
        <v-flex py-1 xs12 text-xs-center>
          <v-layout row wrap>
            <v-flex md1 offset-md5 xs6>
              <v-btn large flat icon color="grey darken-2" href="mailto:pot-betreiber@stusta.de" :ripple="false" rel="noopener">
                <svg style="width:30px;height:30px" viewBox="0 0 24 24">
                  <path fill="#616161" d="M20,8L12,13L4,8V6L12,11L20,6M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z"/>
                </svg>
              </v-btn>
            </v-flex>
            <v-flex xs6 md1>
              <v-btn flat large icon color="grey darken-2" href="https://www.facebook.com/Potschamperl" target="_blank" :ripple="false" rel="noopener">
                <svg style="width:30px;height:30px"  viewBox="0 0 24 24">
                  <path fill="#616161" d="M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M18,5H15.5A3.5,3.5 0 0,0 12,8.5V11H10V14H12V21H15V14H18V11H15V9A1,1 0 0,1 16,8H18V5Z"/>
                </svg>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-footer>
  </v-app>
</template>

<script>
  import axios from 'axios'
  import today from './components/Today'
 
  export default {
    name: 'App',
    components: {
      'Today': today,
      'Plan': () =>
        import ('./components/Plan')
    },
    data() {
      return {
        loading: true,
        plan: Array,
        error: false,
        lastUpdate: Number,
        planShown: false,
        month: Number,
        errorMsg: 'Whoopsey!: Something went wrong'
      }
    },
    created() {
      this.fetch()
    },
    methods: {
      fetch() {
        this.lastUpdate = new Date().getDate();
        axios.get('https://pot.stusta.de/plan.json')
       .then(response => {
         this.plan = response.data.days
         this.month = response.data.month
         return this.getToday()
        })
        .then(() => {
          this.loading = false
          
        })
        .catch(error => {
         this.error = true;
         this.errorMsg = error.message;
         this.loading = false
        })
      },
      getToday(){
        return new Promise((resolve,reject)=> {
          const month = new Date().getMonth()
          if (month != this.month) {
            reject(new Error('Der aktuelle Monatsplan ist (noch) nicht verfügbar!'));
          } else {
            resolve()
          }
        })       
      }      
    },
    watch: {
      update: function(){
        if(this.update){
          console.log("refetch: Plan")
          this.fetch();
        }
      }
    },
    computed: {     
      today() {
        return this.plan[new Date().getDate()-1];       
      },
      update() {
        if(this.lastUpdate != new Date().getDate()) {
          return true;
        } else {
          return false;
        }
      }
    }

  }
</script>

<style>
  body {
    background-color:  #1b1d1e
  }
  .wf-loading.display-2, .wf-loading.display-1, .wf-loading.title, .wf-loading.headline, .wf-loading.title{
    visibility: hidden !important;
  }

  #app {
    background-color: #1b1d1e;
    font-family: reklame-script !important;
  }
  
  #footer {
    background-color: #1b1d1e
  }

  .display-1,
  .title,
  .headline,
  .display-2 {
    font-family: reklame-script !important;
  }
  
  
  
  .loader,
  .loader:before,
  .loader:after {
    background: #fd7400;
    -webkit-animation: load1 1s infinite ease-in-out;
    animation: load1 1s infinite ease-in-out;
    width: 1em;
    height: 4em;
  }
  
  .loader {
    color: #fd7400;
    text-indent: -9999em;
    margin: 88px auto;
    position: relative;
    font-size: 11px;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
  }
  
  .loader:before,
  .loader:after {
    position: absolute;
    top: 0;
    content: '';
  }
  
  .loader:before {
    left: -1.5em;
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
  }
  
  .loader:after {
    left: 1.5em;
  }
  
  @-webkit-keyframes load1 {
    0%,
    80%,
    100% {
      box-shadow: 0 0;
      height: 4em;
    }
    40% {
      box-shadow: 0 -2em;
      height: 5em;
    }
  }
  
  @keyframes load1 {
    0%,
    80%,
    100% {
      box-shadow: 0 0;
      height: 4em;
    }
    40% {
      box-shadow: 0 -2em;
      height: 5em;
    }
  }
</style>
